(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("codeparameter", [], factory);
	else if(typeof exports === 'object')
		exports["codeparameter"] = factory();
	else
		root["codeparameter"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 